'use es6';

export const generateChatflowLabel = chatflow => {
  return chatflow.get('hs_chatflow_name');
};